import PrimaryCell from "../../../../../../../ui/Table/Cells/PrimaryCell";
import ProgramNameCell from "./ProgramNameCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 50
  },
  {
    dataField: "code",
    caption: "Код",
    dataType: "string",
    cellRender: ProgramNameCell,
    width: 100
  },
  {
    dataField: "recurrenceDays",
    caption: "Дни занятий",
    dataType: "string",
    cellRender: PrimaryCell,
  },
  {
    dataField: "startTime",
    caption: "Начало занятий",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 80
  },
  {
    dataField: "endTime",
    caption: "Окончание занятий",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 80
  },
  {
    dataField: "shift",
    caption: "Смена",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 80
  }
];
